// extracted by mini-css-extract-plugin
export default {"container":"hit_commentaries_list-module__container--xSVTM","item":"hit_commentaries_list-module__item--380Uy","list":"hit_commentaries_list-module__list--1Bkxk"};